module.exports = __webpack_public_path__ + "static/media/Twitter.d3c9e05e.svg";